/**
 * Feature flags for game mechanics
 * Set to false to hide UI, but keep code intact for easy reversion
 */
export const FEATURES = {
  // Manual stamina recovery (foraging/resting buttons)
  MANUAL_STAMINA_RECOVERY: false,
  
  // Travel time delays and countdown displays
  TRAVEL_TIMERS: false,
  
  // Settings UI for travel/foraging timers
  SHOW_TIMER_SETTINGS: false,
  
  // Generate new terrain narratives (disable when narrative pool is sufficient)
  // With 30 narratives per terrain type, generation should never be needed
  GENERATE_NEW_TERRAIN_NARRATIVES: false,
} as const;

